import { TFunction } from 'i18next'

/**
 * Get a properly formatted display name for consultation types
 * @param type - Consultation type key
 * @param t - Translation function
 * @returns Localized display name
 */
export function getTypeDisplayName(type: string, t: TFunction): string {
  // Map known type keys to readable names
  const typeDisplayNames: Record<string, string> = {
    classic: t('common:model.consultation.type.classic'),
    emergency: t('common:model.consultation.type.emergency'),
    local: t('common:model.consultation.type.local'),
    meeting_only: t('common:model.consultation.type.meeting_only'),
    netsoins: t('common:model.consultation.type.netsoins'),
    pedcl: t('common:model.consultation.type.pedcl'),
  }

  return typeDisplayNames[type] || type
}
